import { render } from "./RealReg_Page.vue?vue&type=template&id=89fd4a84"
import script from "./RealReg_Page.vue?vue&type=script&lang=js"
export * from "./RealReg_Page.vue?vue&type=script&lang=js"

import "./RealReg_Page.vue?vue&type=style&index=0&id=89fd4a84&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__